module.exports = __webpack_public_path__ + "img/upi-logo.88581cef.png";